import { useState } from 'react';
import { api } from '../api-client';
import { tenantStore } from '../lib/tenant-store';

export default function TenantSetup() {
  const [tenantId, setTenantId] = useState(tenantStore.get() ?? '');
  const [sourceCart, setSourceCart] = useState('bcart');
  const [plan, setPlan] = useState('entry');
  const [message, setMessage] = useState('');

  async function handleCreate() {
    try {
      const { tenant } = await api.createTenant({
        id: tenantId || undefined,
        sourceCart,
        plan,
      });
      tenantStore.set(tenant.id);
      setTenantId(tenant.id);
      setMessage(`✓ テナント作成: ${tenant.id}`);
    } catch (e) {
      setMessage(`✗ エラー: ${(e as Error).message}`);
    }
  }

  function handleUse() {
    if (tenantId) {
      tenantStore.set(tenantId);
      setMessage(`✓ テナントを設定: ${tenantId}`);
    }
  }

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">テナント設定</h2>

      <div className="bg-white rounded shadow border p-6 max-w-xl space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">テナントID（空欄でUUID自動生成）</label>
          <input
            value={tenantId}
            onChange={(e) => setTenantId(e.target.value)}
            placeholder="例: my-company"
            className="w-full px-3 py-2 border rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">カートシステム</label>
          <select
            value={sourceCart}
            onChange={(e) => setSourceCart(e.target.value)}
            className="w-full px-3 py-2 border rounded"
          >
            <option value="bcart">Bcart</option>
            <option value="bcart-mock">Bcart (Mock for PoC)</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">プラン</label>
          <select value={plan} onChange={(e) => setPlan(e.target.value)} className="w-full px-3 py-2 border rounded">
            <option value="entry">エントリー (月5,000円)</option>
            <option value="standard">スタンダード (月15,000円)</option>
            <option value="pro">プロ (月30,000円)</option>
          </select>
        </div>

        <div className="flex gap-2">
          <button onClick={handleCreate} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
            新規作成
          </button>
          <button onClick={handleUse} className="px-4 py-2 bg-slate-200 rounded hover:bg-slate-300">
            既存IDを使用
          </button>
        </div>

        {message && <p className="text-sm">{message}</p>}
      </div>
    </div>
  );
}
